/* import __COLOCATED_TEMPLATE__ from './recovery-codes-modal.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type IntlService from 'ember-intl/services/intl';

interface Args {
  isOpen: boolean;
  onClose: () => void;
  codes: string;
}

interface Signature {
  Args: Args;
  Element: never;
}

export default class RecoveryCodesModal extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare notificationsService: $TSFixMe;

  @tracked isCodesVisible = false;
  _wasOpenPreviously = false;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    this._wasOpenPreviously = this.args.isOpen;
  }

  @action
  handleModalStateChange() {
    if (this.args.isOpen && !this._wasOpenPreviously) {
      this.isCodesVisible = false;
      this._wasOpenPreviously = true;
    } else if (!this.args.isOpen) {
      this._wasOpenPreviously = false;
    }
  }

  @action
  toggleCodesVisibility() {
    this.isCodesVisible = !this.isCodesVisible;
  }

  @action
  downloadCodes() {
    let blob = new Blob([this.args.codes], { type: 'text/plain' });
    let url = window.URL.createObjectURL(blob);
    let link = document.createElement('a');
    link.href = url;
    link.download = 'intercom_two_factor_recovery_codes.txt';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    this.notificationsService.notifyConfirmation(
      this.intl.t('account.general.recovery-codes-downloaded'),
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Common::RecoveryCodesModal': typeof RecoveryCodesModal;
  }
}
